var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcrossEmptystateClouds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 120,
    viewBox: "0 0 185 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 60,
    r: 60,
    fill: "#6CF9D8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7183 67.2697C12.5876 62.5406 1.13147 79.3856 0 89H124C124 84.0288 119.091 78.8862 110.648 78.8862C109.517 68.7723 94.7605 47 71.3297 47C47.8988 47 42.1943 56.3599 32.7183 67.2697Z",
    fill: "url(#paint0_linear_800_30150)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.544 29.961C176.361 26.4704 184.223 38.9037 185 46H101C101 39.983 104.106 37.9094 109.057 38.535C109.834 31.07 119.961 15 136.043 15C152.125 15 156.04 21.9085 162.544 29.961Z",
    fill: "url(#paint1_linear_800_30150)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_800_30150",
    x1: 57.5,
    y1: 38,
    x2: 57.5,
    y2: 96.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#6CF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56C9AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_800_30150",
    x1: 143,
    y1: 15,
    x2: 143,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F0F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcrossEmptystateClouds);
export default __webpack_public_path__ + "static/media/across-emptystate-clouds.4e016907.svg";
export { ForwardRef as ReactComponent };